/**
 *
 * 发布车源
 */
const obj = {
    state: {
        brandInfo: {}, //车型品牌
        brand:{},
        cityInfo:{},//选择的城市信息
        locationCity:{},
        registerCity:{},
    },
    mutations: {
        setBrandInfo:(state, data) =>{
            state.brandInfo = data
        },
        setBrand:(state,data) =>{
            state.brand = data
        },
        setCityInfo:(state, data) =>{
            state.cityInfo = data
        },
        setLocationCity:(state, data) =>{
            state.locationCity = data
        },
        setRegisterCity:(state, data) =>{
            state.registerCity = data
        },
    },
    actions: {
    
    }
}

export default obj



// WEBPACK FOOTER //
// ./src/store/publishCar.js